class CollapsibleContent extends HTMLElement {
  constructor() {
    super()

    this.triggers = this.querySelectorAll('.trigger')

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.handleTriggerClick.bind(this))
      trigger.addEventListener('keydown', this.handleTriggerKeydown.bind(this))
    })
  }

  handleTriggerKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return

    event.preventDefault()
    event.currentTarget.click()
  }

  handleTriggerClick({ currentTarget }) {
    const activeAccordion = this.querySelector('.active.accordion-group')

    if (activeAccordion && activeAccordion != currentTarget.parentElement) {
      const activeDrawer = activeAccordion.querySelector('.accordion-drawer')

      activeAccordion.classList.remove('active')
      activeDrawer?.removeAttribute('style')
      activeDrawer?.setAttribute('aria-hidden', 'true')
      activeAccordion.querySelector('.trigger')?.setAttribute('aria-expanded', 'false')
    }

    const drawerEl = currentTarget.nextElementSibling

    if (!drawerEl) return

    drawerEl?.getAttribute('style')
      ? (drawerEl.removeAttribute('style'), drawerEl.setAttribute('aria-hidden', 'true'))
      : (drawerEl.setAttribute('style', `height: ${drawerEl.scrollHeight}px`),
        drawerEl.setAttribute('aria-hidden', 'false'))

    const isExpanded = currentTarget.parentElement.classList.toggle('active')
    currentTarget.setAttribute('aria-expanded', `${isExpanded}`)
  }
}

customElements.define('collapsible-content', CollapsibleContent)
